<div>
  <ng-container *ngFor="let chat of visibleChats; let i = index">
    <div class="message-chat-wrap" [ngClass]="{'second': i === 1, 'job-page-chat': isJob}">
      <app-chat-view-component (triggerParentAction)="closeChat($event)" [profiles]="chat" [jobId]="jobId" [jobInfo]="jobInfo"></app-chat-view-component>
    </div>
  </ng-container>
  
  <div *ngIf="hiddenChats.length > 0" class="chat-overflow d-flex align-items-center justify-content-end">
    <ng-container *ngFor="let chat of hiddenChats">
      <div class="chat-avatar-square" title="{{ chat[0].displayName }}" (click)="promoteHiddenChat(chat)">
        {{ chat[0].displayName.charAt(0).toUpperCase() }}
      </div>
    </ng-container>
  </div>
</div>
